import { ResponsiveImage } from "@/components/responsive-image";
import type { RasterImageSet } from "@/generated/raster-images";
import { cn } from "@/lib/utils";

export function HeroBackgroundPicture({
  image,
  alt,
  className,
  objectPosition = "center",
}: {
  image: RasterImageSet;
  alt: string;
  className?: string;
  objectPosition?: string;
}) {
  return (
    <div className="absolute inset-0 z-0">
      <ResponsiveImage
        image={image}
        alt={alt}
        className={cn("w-full h-full object-cover", className)}
        style={{ objectPosition }}
        sizes="100vw"
        loading="eager"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary/90 to-primary/60" />
      <div className="absolute inset-0 bg-gradient-to-b from-primary/40 via-primary/20 to-primary/30 md:from-primary/20 md:to-transparent" />
    </div>
  );
}
